import { ConnectionsEmptyOrError } from '@terminal/modules/overview-knowledge-graph/components/shared/connections-error-or-empty/ConnectionsEmptyOrError';

import styles from './OverviewTab.module.scss';

export interface OverviewSectionErrorFallbackProps {
  title: string;
}

export const OverviewSectionErrorFallback = ({
  title,
}: OverviewSectionErrorFallbackProps) => {
  return (
    <div className={styles.sectionErrorWrapper}>
      <div className={styles.sectionTitle}>{title}</div>
      <ConnectionsEmptyOrError variant="error" errorSize="compact" />
    </div>
  );
};
